import script from "./SettlementList.vue?vue&type=script&setup=true&lang=js"
export * from "./SettlementList.vue?vue&type=script&setup=true&lang=js"

import "./SettlementList.vue?vue&type=style&index=0&id=591afb5a&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-591afb5a"]])

export default __exports__